import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Affiliate,
  BookingDetails,
  BookingLink,
  BookingLinkNotFound,
  ConfirmBooking,
  FinalizeBooking,
  RaiseDispute,
  ReviewBooking,
  Login,
  Schedule,
  Signup,
  Success,
  Welcome,
  WhyAffiliate,
} from "./pages";

export const WebRoutes = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route index path="/" element={<Welcome />} />
          <Route index path="/login" element={<Login />} />
          <Route index path="/signup" element={<Signup />} />
          <Route index path="/profile/:slug" element={<BookingLink />} />
          <Route index path="/schedule" element={<Schedule />} />
          <Route index path="/finalize-booking" element={<FinalizeBooking />} />
          <Route index path="/success" element={<Success />} />
          <Route index path="/affiliate" element={<Affiliate />} />
          <Route index path="/why-affiliate" element={<WhyAffiliate />} />
          <Route
            index
            path="/booking-link-not-found"
            element={<BookingLinkNotFound />}
          />
          <Route
            index
            path="/confirm-booking/:id"
            element={<ConfirmBooking />}
          />
          <Route index path="/raise-dispute/:id" element={<RaiseDispute />} />
          <Route index path="/review-booking" element={<ReviewBooking />} />
          <Route
            index
            path="/booking-details/:id"
            element={<BookingDetails />}
          />
        </Routes>
      </Router>
    </>
  );
};
